/**
 * Application Constants and Enums
 *
 * Pure-string shipping constants live in ./shippingConstants.js so that
 * server code (Node, no webpack) can import them too. This file re-exports
 * those, then adds image-asset maps and auth/checkout constants that are
 * client-only.
 */

// ============================================================================
// CARRIER ICON IMPORTS
// Used for displaying carrier logos in shipping selection UI
// ============================================================================
import australiaPost from '../assets/carrierIcons/australiaPost.png';
import canadaPost from '../assets/carrierIcons/canadaPost.png';
import dhl from '../assets/carrierIcons/dhl.png';
import fedex from '../assets/carrierIcons/fedex.png';
import ups from '../assets/carrierIcons/ups.png';
import usps from '../assets/carrierIcons/usps.png';
import uspsLogo from '../assets/usps-logo.ec465bb0e3d017c6055dd1aa86234e41.png';
import fedexLogo from '../assets/fedex-logo.svg';
import upsLogo from '../assets/ups-logo.28ef2757acc2c805a47f22be998e9222.svg';

// Local re-imports so the image-map constants below can reference them.
// Must sit alongside the other imports (not interleaved with exports) to
// satisfy the eslint import/first rule.
import { USPS as USPS_CODE, FEDEX as FEDEX_CODE, UPS as UPS_CODE } from './shippingConstants';

// ============================================================================
// SHARED SHIPPING CONSTANTS
// Re-exported from shippingConstants.js so the server can use the same
// strings via require(). Editing the values must happen there.
// ============================================================================
export {
  DOMESTIC,
  INTERNATIONAL,
  FLAT_RATE,
  CALCULATED,
  ADD,
  SUBTRACT,
  MEDIAMAIL,
  USPS_PRIORITY,
  GROUND_ADVANTAGE,
  FIRST_CLASS_PACKAGE_INTERNATIONAL_SERVICE,
  PRIORITY_MAIL_INTERNATIONAL,
  EXPRESS_MAIL_INTERNATIONAL,
  SMART_POST,
  STANDARD_OVERNIGHT,
  PRIORITY_OVERNIGHT,
  FEDEX_2_DAY,
  FEDEX_GROUND,
  FEDEX_EXPRESS_SAVER,
  EXPRESS,
  FEDEX_INTERNATIONAL_CONNECT_PLUS,
  INTERNATIONAL_ECONOMY,
  FEDEX_INTERNATIONAL_PRIORITY,
  NEXT_DAY_AIR,
  NEXT_DAY_AIR_SAVER,
  SECOND_DAY_AIR,
  THREE_DAY_SELECT,
  GROUND,
  EXPEDITED,
  UPS_SAVER,
  DHL_EXPRESS_WORLDWIDE_NONDOC,
  DHL_PARCEL_INTERNATIONAL_DIRECT,
  DHL_PARCEL_INTERNATIONAL_STANDARD,
  DHL_PACKET_INTERNATIONAL,
  CANADA_POST_REGULAR_PARCEL,
  CANADA_POST_EXPEDITED_PARCEL,
  CANADA_POST_XPRESSPOST,
  CANADA_POST_PRIORITY,
  CANADA_POST_TRACKED_PACKET_USA,
  CANADA_POST_EXPEDITED_PARCEL_USA,
  CANADA_POST_XPRESSPOST_USA,
  CANADA_POST_PRIORITY_WORLDWIDE,
  CANADA_POST_TRACKED_PACKET_INTERNATIONAL,
  CANADA_POST_XPRESSPOST_INTERNATIONAL,
  ECONOMY_SERVICES,
  STANDARD_SERVICES,
  EXPEDITED_SERVICES,
  ONE_DAY_SERVICE,
  INTERNATIONAL_SERVICES,
  USPS,
  FEDEX,
  UPS,
  DeliveryMethod,
} from './shippingConstants';

// A carrier's name as people read it ('FedExDefault' -> 'FedEx'); one helper for the whole app
export { formatCarrierName as getCarrierDisplayName } from './genericHelpers';

// ============================================================================
// AUTHENTICATION & USER FLOWS — client-only
// ============================================================================
export const SIGNUP = 'signup';
export const LOGIN = 'login';

// ============================================================================
// CHECKOUT FLOW STEPS — client-only
// ============================================================================
export const CHECKOUT_STEPS = {
  SHIPPING_DETAILS: 'shippingDetails',
  CARRIERS: 'carriers',
  PAYMENT_DETAILS: 'paymentDetails',
  STRIPE: 'stripe',
  WALLET: 'wallet',
};

// ============================================================================
// CARRIER ICONS & LOGOS — client-only (image assets)
// ============================================================================

export const renderCarrierIcons = {
  USPS: usps,
  UPS: ups,
  UPSDAP: ups,
  FEDEX: fedex,
  FedExDefault: fedex,
  DHL: dhl,
  DHLExpress: dhl,
  AUSTRALIAPOST: australiaPost,
  CANADAPOST: canadaPost,
};

export const carrierLogos = {
  [USPS_CODE]: uspsLogo,
  [FEDEX_CODE]: fedexLogo,
  [UPS_CODE]: upsLogo,
  dhlexpress: dhl,
  dhlecommercesolutions: dhl,
  canadapost: canadaPost,
};
